import "normalize.css";

import {
  Basketball,
  Contest,
  ContestForm,
  HeroTicket,
  LineUp,
  NewsList,
  SmoothScroll,
} from "./services";
import { SocialPosts } from "./services/SocialPosts";

class App {
  smoothScroll: SmoothScroll;
  mainContainer: HTMLElement;
  isLocalDev = location.host === "localhost:1234";

  hasLoadedPage = false;

  constructor() {
    this.smoothScroll = new SmoothScroll();
    this.mainContainer = document.querySelector(
      "#homepage-main"
    ) as HTMLElement;

    this.init();
  }

  async init() {
    this.mainContainer.style.setProperty("opacity", "0");

    document.body.addEventListener(
      "loader-25:completed",
      this.onPageLoaderComplete
    );

    const dataPath = this.isLocalDev
      ? "./data.json"
      : `${location.origin}/wp-content/themes/nba-represent/_inc/data.php`;

    const jsonData = await fetch(`${dataPath}?nocache=${Date.now()}`, {
      cache: "no-store",
    });

    const data = await jsonData.json();

    // Contest markup can be commented out of the homepage template, so only
    // boot the contest-related modules when their elements are present.
    if (document.querySelector("#hero-ticket")) {
      new HeroTicket(data.NEXT_CONTEST_TIMESTAMP);
    }

    new LineUp({
      lenis: this.smoothScroll.lenis,
      players: data.PLAYERS,
      dataKeyAbbreviation: data.DATA_KEY_ABBREVIATION,
    });

    if (document.querySelector("[data-basketball]")) {
      new Basketball();
    }

    if (document.querySelector("[data-contest-tab-control-list]")) {
      new Contest(data.CONTEST_TIMESTAMPS);
    }

    if (document.querySelector("#contest-form")) {
      new ContestForm({
        lenis: this.smoothScroll.lenis,
      });
    }

    new SocialPosts();

    new NewsList();

    if (this.isLocalDev) {
      document.body.dispatchEvent(new CustomEvent("loader-25:completed"));
      document.body.dispatchEvent(new CustomEvent("loader-25:loader-exited"));
    }
  }

  onPageLoaderComplete = () => {
    if (this.hasLoadedPage) {
      return;
    }

    this.hasLoadedPage = true;
    this.mainContainer.style.removeProperty("opacity");

    (
      document.body.querySelector("#homepage-hero-video") as HTMLVideoElement
    ).currentTime = 0;
  };
}

new App();
